import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=4c570816&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=ts"
export * from "./TableActions.vue?vue&type=script&lang=ts"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=4c570816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c570816",
  null
  
)

export default component.exports